<template>
  <div class="main">
    <div class="nav">折扣</div>
    <div class="content">
      <div class="left">
        <!-- 活动名称 -->
        <div class="title">
          <h4>活动名称</h4>
          <el-input class="goodsInput" v-model="value" placeholder="请输入活动名称" size="small"></el-input>
        </div>
        <!-- 优惠类型 -->
        <div class="title">
          <h4>优惠类型</h4>
          <div>
            <el-select v-model="discountType" placeholder="请选择" size="small" class="selectInput">
              <el-option
                v-for="item in discountTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="inputContent" v-if="discountType===1">
              <div>优惠金额</div>
              <div>
                <span>$</span>
                <input type="number" v-model="value" placeholder="请输入优惠金额" />
              </div>
            </div>
            <div class="inputContent" v-if="discountType===2">
              <div>折扣额度</div>
              <div>
                <input
                  type="text"
                  v-model="amount"
                  placeholder="如输入12,相当于适用对象八八折"
                  @keyup="amountChange"
                />
                <span>%</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 适用对象 -->
        <div class="title" v-if="discountType!=3">
          <h4>适用对象</h4>
          <div class="applyObj">
            <el-select v-model="applyObj" placeholder="请选择" size="small">
              <el-option
                v-for="item in applyObjs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="primary"
              size="small"
              class="btn"
              v-if="applyObj===2"
              @click="dialogSeriesList=true"
            >添加系列</el-button>
            <el-button
              type="primary"
              size="small"
              class="btn"
              v-if="applyObj===3"
              @click="dialogGoodList=true"
            >添加商品</el-button>
            <!-- 系列列表弹出层 -->
            <el-dialog
              title="请选择商品系列"
              :visible.sync="dialogSeriesList"
              style="z-index: 10001;"
              width="650px"
              :close-on-click-modal="false"
            >
              <!-- 商品系列列表 -->
              <good-serieslist></good-serieslist>
              <div class="foot" style="text-align:center">
                <el-button type="primary" @click="dialogSeriesList = false" size="small">确 定</el-button>
                <el-button @click="dialogSeriesList = false" size="small">取 消</el-button>
              </div>
            </el-dialog>

            <!-- 商品列表弹出层 -->
            <el-dialog
              title="请选择商品"
              :visible.sync="dialogGoodList"
              style="z-index: 10001;"
              width="650px"
              :close-on-click-modal="false"
            >
              <!-- 商品列表 -->
              <good-list></good-list>
              <div class="foot" style="text-align:center">
                <el-button type="primary" @click="dialogGoodList = false" size="small">确 定</el-button>
                <el-button @click="dialogGoodList = false" size="small">取 消</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
        <!-- 生效条件 -->
        <div class="title">
          <h4>生效条件</h4>
          <div>
            <el-select v-model="conpre" placeholder="请选择" size="small" class="selectInput">
              <el-option
                v-for="item in conpres"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="conpreContent">
              <div class="inputContent" v-if="conpre===2">
                <p class="conpre">
                  <span>$</span>
                  <input type="text" v-model="value" placeholder="请输入优惠金额" size="small" />
                </p>
              </div>
              <h4 v-if="conpre===2">仅适用于指定商品</h4>
            </div>
          </div>
        </div>
        <!-- 有效日期 -->
        <div class="title">
          <h4>
            有效日期
            <span style="font-size:12px;color:#C0C4CC;">（开始时间按设置日期的北京时间0时开始，结束时间按设置日期的北京时间24时结束）</span>
          </h4>
          <div class="dateContent">
            <div class="date">
              <div>开始日期</div>
              <div style="padding-left:0;" class="selectDate">
                <el-date-picker
                  v-model="date1"
                  type="date"
                  placeholder="选择日期"
                  size="small"
                  style="border:none;"
                  :start-placeholder="date1"
                  value-format="yyyy-MM-dd"
                  :picker-options="expireTimeOption"
                ></el-date-picker>
              </div>
            </div>
            <div class="date">
              <div>结束日期</div>
              <div style="padding-left:0;" class="selectDate">
                <el-date-picker
                  v-model="date2"
                  :picker-options="expireTimeOption"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="不填则永久有效"
                  size="small"
                ></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <!-- 优惠码 -->
        <div class="proCode">
          <h4>
            <span>优惠码</span>
            <span v-show="!preCode">点击生成优惠码</span>
          </h4>
          <div>
            <el-checkbox v-model="preCode">自动应用优惠</el-checkbox>
          </div>
          <el-input
            class="goodsInput"
            v-model="value"
            placeholder="请输入优惠码，如：XMAS20OFF"
            size="small"
          ></el-input>
        </div>
      </div>
      <!-- 右侧优惠活动 -->
      <div class="right">
        <div class="discountCard">
          <h2>优惠活动名称</h2>
          <ul>
            <li>
              <span>优惠码</span>
              <span>{{ value }}</span>
            </li>
            <li>
              <span>优惠类型</span>
              <span v-if="discountType===1">{{ value?`减免$${value} ($${value} off)`:'--' }}</span>
              <span v-if="discountType===2">{{ amount?`减免$${amount} ($${amount} off)`:'--' }}</span>
              <span v-if="discountType===3">{{ '免运费 (Free shipping)' }}</span>
            </li>
            <li v-if="conpre===2">
              <span>生效条件</span>
              <span>{{ `最低消费金额$${value} (Mininum purchase of $${value} off)` }}</span>
            </li>
            <li>
              <span>有效时间</span>
              <span>{{ date1+' 至 ' }}{{ date2?date2:'永久有效' }}</span>
            </li>
          </ul>
        </div>
        <div class="warmPrompt">
          <h3>温馨提示</h3>
          <p>折扣码与自动折扣无法同时使用。如果在结账时使用了手动优惠码，那么自动优惠将失效。</p>
        </div>
      </div>
    </div>
    <div class="btn footBtn">
      <el-button type="primary" size="small">确 定</el-button>
      <el-button size="small" @click="enterDiscount">取 消</el-button>
    </div>
  </div>
</template>

<script>
import goodSerieslist from "./goodSerieslist";
import goodList from "./goodList";
export default {
  data() {
    return {
      discountType: 1, // 优惠类型
      discountTypes: [
        {
          value: 1,
          label: "固定优惠"
        },
        {
          value: 2,
          label: "%折扣"
        },
        {
          value: 3,
          label: "免运费"
        }
      ],
      applyObj: 1, //适用对象
      applyObjs: [
        {
          value: 1,
          label: "整个订单"
        },
        {
          value: 2,
          label: "指定商品系列"
        },
        {
          value: 3,
          label: "指定商品"
        }
      ],
      conpre: 1, //生效条件
      conpres: [
        {
          value: 1,
          label: "不限"
        },
        {
          value: 2,
          label: "消费满"
        }
      ],
      value: "",
      value1: "",
      amount: "", //折扣额度
      dialogSeriesList: false, //系列列表弹出层
      dialogGoodList: false, //商品列表弹出层
      preCode: false, //自动应用优惠
      date1: "", //时间选择器开始时间
      date2: "", //时间选择器结束时间
      expireTimeOption: {
        //时间选择器当日之前的日期不可选中
        disabledDate(date) {
          return date.getTime() <= Date.now();
        }
      }
    };
  },
  created() {
    this.getNowTime();
  },
  methods: {
    enterDiscount() {
      this.$router.push({
        path: "/discount"
      });
    },
    // 时间选择器默认显示当日
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.date1 = defaultDate;
    },
    //折扣发生改变
    amountChange() {
      if (this.amount.length == 1) {
        this.amount = this.amount.replace(/[^1-9]/g, "");
      } else {
        this.amount = this.amount.replace(/\D/g, "");
      }
      if (this.amount.length >= 3) {
        this.amount = this.amount.slice(0, 2);
      }
      this.amount - 0;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`

    this.$confirm("您的操作将不会被保存, 是否继续??", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        next();
      })
      .catch(() => {});
  },
  components: {
    goodSerieslist,
    goodList
  }
};
</script>

<style lang="less" scoped>
.add {
  padding: 0;
  span {
    display: inline-block;
    padding: 0 20px;
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
}
.main {
  padding-top: 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  > .content {
    padding-left: 30px;
    display: flex;
    justify-content: space-between;
    > .left {
      width: 60%;
      .title {
        > div {
          display: flex;
          .selectInput {
            margin-right: 12px;
          }
        }
        > h4 {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: rgba(34, 34, 34, 1);
          line-height: 20px;
          margin-top: 20px;
          margin-bottom: 6px;
        }
        .goodsInput {
          height: 40px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
        }
        > span {
          margin-left: 6px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 119, 255, 1);
          line-height: 20px;
          &:hover {
            cursor: pointer;
          }
        }
        .inputContent {
          width: 100%;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          display: flex;
          > div:nth-child(1) {
            width: 20%;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #dcdfe6;
          }
          > div:nth-child(2),
          .conpre {
            width: 80%;
            display: flex;
            align-items: center;
            color: #dcdfe6 !important;
            padding-left: 12px;
            height: 30px;
            > span {
              padding-right: 10px;
            }
            input {
              width: 100%;
            }
            input::-webkit-input-placeholder {
              /* WebKit browsers */
              color: #dcdfe6;
            }

            input::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #dcdfe6;
            }

            input:-ms-input-placeholder {
              /* Internet Explorer 10+ */
              color: #dcdfe6;
            }
          }
        }
        .conpreContent {
          width: 100%;
          h4 {
            margin-top: 0;
            height: 30px;
            line-height: 30px;
          }
        }
        .applyObj {
          width: 100%;
          > div {
            width: 100%;
          }
          .btn {
            margin-left: 20px;
          }
        }
      }
    }
    > .right {
      width: 36%;
      > .discountCard {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        margin-bottom: 20px;
        padding: 20px;
        > h2 {
          color: #1a1d2c;
          text-align: center;
          font-size: 16px;
          line-height: 22px;
          margin: 10px 0 10px;
          font-weight: 600;
        }
        li {
          margin-bottom: 12px;
          display: flex;
          > span:nth-child(1) {
            display: inline-block;
            width: 80px;
          }
          > span:nth-child(2) {
            display: inline-block;
            flex: 1;
          }
        }
      }
      > .warmPrompt {
        padding: 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        h3 {
          font-weight: 500;
          margin-bottom: 10px;
        }
      }
    }
  }
  > .nav {
    line-height: 24px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: 600;
  }
}
.selectDate {
  display: flex;
  align-items: center;
  /deep/ .el-input__inner {
    border-radius: 0 4px 4px 0;
    box-sizing: border-box;
  }
}
.dateContent {
  display: flex;
  justify-content: space-between;
}
.date {
  display: flex;
  align-items: center;
  > div:nth-child(1) {
    height: 30px;
    line-height: 30px;
    padding: 0 12px;
    border: 1px solid #dcdfe6;
    border-right: 0px;
    border-radius: 4px 0 0 4px;
  }
}
.proCode {
  margin-top: 12px;
  > h4 {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 6px;
    > span:nth-child(1) {
      font-weight: 600;
    }
    > span:nth-child(2) {
      color: #1980ff;
      &:hover {
        cursor: pointer;
      }
    }
  }
  > div {
    margin-top: 6px;
  }
}
.footBtn {
  text-align: center;
  margin-top: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}
</style>